import React from "react"
import { ServicePageLayout } from "../../components/services/ServicePageLayout"
import { METADATA } from "../../components/meta/metadata"

export default function StrategicTransformationPage() {
  return (
    <ServicePageLayout
      title={METADATA.strategicTransformation.title}
      metaDescription={METADATA.strategicTransformation.description}
      backgroundImage="/images/backgrounds/flickr-473770493.jpg"
      backgroundAlt="Strategic Transformation"
      headline="Strategic Transformation Partnerships"
      tagline="Comprehensive AI transformation for organisations committed to lasting change."
      introContent={[
        "Some organisations need more than a programme. They need an embedded partner who understands their operations deeply, builds capability systematically and transfers knowledge at every step. Strategic Transformation Partnerships provide exactly this.",
        "We work alongside your teams throughout the engagement - building enterprise-wide Knowledge Architecture, deploying Partner AI tailored to your needs and progressively transferring capability. We use our deep expertise to set things up properly, then ensure your teams can maintain and evolve these systems independently."
      ]}
      deliverables={[
        {
          title: "Embedded consulting presence",
          description: "Senior consultants working alongside your teams, understanding your operations from the inside"
        },
        {
          title: "Enterprise-wide Knowledge Architecture",
          description: "Comprehensive structuring of institutional knowledge across your organisation"
        },
        {
          title: "Partner AI deployment",
          description: "AI systems tailored to your needs - whether a single enterprise-wide solution or multiple for different teams and functions"
        },
        {
          title: "Organisational change support",
          description: "Guidance on adoption, governance and cultural change that makes AI stick"
        },
        {
          title: "Capability transfer",
          description: "Systematic training and handover ensuring your teams can maintain and evolve AI capabilities"
        },
        {
          title: "Ongoing optimisation",
          description: "Regular refinement based on usage, feedback and evolving business needs"
        }
      ]}
      processSteps={[
        {
          title: "Discovery and Planning",
          description: "Deep engagement to understand your organisation, strategic objectives and transformation priorities. We create a phased plan with clear milestones."
        },
        {
          title: "Phased Implementation",
          description: "Systematic rollout across your organisation. Each phase delivers tangible value while building towards the larger transformation. Regular check-ins ensure alignment."
        },
        {
          title: "Knowledge Transfer Throughout",
          description: "We do not wait until the end to transfer knowledge. Your teams learn alongside us, building capability from day one."
        },
        {
          title: "Transition to Internal Ownership",
          description: "Clear handover ensuring your organisation can maintain, extend and evolve AI capabilities independently. We leave you stronger, not dependent."
        }
      ]}
      benefits={[
        {
          title: "Deep Organisational Integration",
          description: "We become part of your team, understanding context that surface-level engagements miss. This depth enables better solutions."
        },
        {
          title: "Sustainable Long-Term Capability",
          description: "Not a one-off project but lasting organisational change. Your teams gain skills and confidence to continue evolving AI capabilities."
        },
        {
          title: "Full Transformation, Not Point Solutions",
          description: "Comprehensive change across your organisation, not isolated experiments. Knowledge Architecture that spans teams and functions."
        },
        {
          title: "Partnership, Not Vendor Relationship",
          description: "We succeed when you succeed. Our incentives align with building your capability, not creating dependency."
        }
      ]}
      audience={[
        "Enterprises seeking comprehensive AI transformation",
        "Organisations with complex operational environments",
        "Leadership teams committed to multi-year AI strategy",
        "Organisations wanting embedded expertise, not just advice",
        "Those ready to invest in lasting capability change"
      ]}
      relatedServices={[
        {
          name: "AI Kickstarter",
          description: "8-week programme for organisations wanting faster, more focused initial engagement",
          href: "/services/ai-kickstarter"
        },
        {
          name: "Knowledge Engineering",
          description: "Standalone knowledge structuring for specific areas",
          href: "/services/knowledge-engineering"
        }
      ]}
      ctaHeadline="Ready for Transformation?"
      ctaDescription="Strategic Transformation Partnerships require significant commitment from both sides. Let's discuss whether this approach fits your organisation's needs and ambitions."
      ctaButtonText="Schedule a Conversation"
    />
  )
}
